import { z } from 'zod';
import { automationTargetSchema } from '../models/automationAssistant.schema';

export const getAutomationTargets = (queueId: number) => {
  return {
    endpoint: `/queues/${queueId}/automation/targets`,
    method: 'GET',
    responseSchema: z.object({ results: z.array(automationTargetSchema) }),
  } as const;
};
